import styled from '@emotion/styled';
import { fromThemeColors, ThemeColor } from '@sharefiledev/flow-web';
import { Tabs } from 'antd';
import { FieldColors } from '../../../common/componentUtils';

const width = '100%';
const borderColor = fromThemeColors(ThemeColor.border)({ theme: {} });

export const StyledTabs = styled(Tabs)`
	height: 100%;
	.ant-tabs-tabpane {
		padding-left: 0 !important;
	}
	.ant-tabs-nav {
		max-width: 50px !important;
	}
	.ant-tabs-tab {
		height: 46px;
		padding: 8px 17px !important;
	}
`;

export const StyledFieldItem = styled.div<{ optionColor: string }>(
	({ optionColor: color }) => `
	box-sizing: border-box;
	display: flex;
	align-items: center;
	padding: 12px 16px;
	gap: 16px;
	isolation: isolate;
	cursor: pointer;
	
	width: ${width};
	height: 48px;
	
	background: ${fromThemeColors(ThemeColor.inputBackground)};
	
	border: 1px solid ${borderColor};
	border-radius: 8px;
	
	.field-label-text{
		color: ${FieldColors['greyscale']}
	}
	&:hover{
		box-shadow: 0px 1px 5px 0px #0000003D;
		.field-label-text{
			color: ${color};
		}
	}
	&.selected-component{
		border: 2px solid ${color};
		.field-label-text{
			color: ${color};
		}
	}
`
);

export const StyledLeftPanel = styled.div`
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0;
	width: 20%;
	min-width: 226px;
	max-width: 320px;
	background: ${fromThemeColors(ThemeColor.inputBackground)};
	border-right: 1px solid ${borderColor};
`;

export const StyledSignerSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 24px;
	height: 130px;
	border-bottom: 1px solid ${borderColor};
	padding-bottom: 0px;
`;

export const StyledFieldsSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 24px;
`;

export const StyledFields = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0;
	gap: 8px;
	width: ${width};
`;

export const StyledSelectLabel = styled.div`
	display: flex;
	align-items: baseline;
	&.border {
		border-top: 1px solid ${borderColor};
	}
`;

export const StyledSelectOptionDot = styled.span<{ optionColor: string }>(
	({ optionColor: color }) => `
	margin-right: 10px;
	width: 12px;
	min-width: 12px;
	height: 12px;
	border-radius: 50%;
	background: ${color}
`
);

export const StyledDisplayLineBreak = styled.span`
	white-space: pre-line;
	max-width: 190px;
	display: flex;
	align-items: center;
`;

export const StyledDescription = styled.span`
	color: ${fromThemeColors(ThemeColor.metadataText)};
	line-height: 24px;
	margin: 4px 0px 16px;
`;
export const StyledSignerDescription = styled.span`
	color: ${fromThemeColors(ThemeColor.metadataText)};
	line-height: 24px;
	margin: 2px 0px 7px;
	width: max-content;
`;

export const StyledSignerInputDropdown = styled.span`
	width: 100%;
	button .border {
		border-top: 0px;
	}
	margin: 12px 0 6px;
`;

export const StyledToolTipWrapper = styled.span`
	> span {
		display: flex;
		margin-left: 5px;
		margin-top: 0px;
	}
`;

export const StyledSectionTitle = styled.span`
	font-size: 16px;
`;

export const StyledSectionTitleField = styled.span`
	font-size: 16px;
	margin-bottom: 2px;
`;
